import { Controller, SubmitHandler, FormProvider, useForm, FieldPath } from "react-hook-form"
import { useParams } from "react-router"
import { useState, useEffect, useRef } from "react"
import LabeledInput from "../../../../../shared/components/UniversalEditModal/components/LabeledInput"
import LabeledTextarea from "../../../../../shared/components/UniversalEditModal/components/LabeledTextarea"
import LabeledSelect from "../../../../../shared/components/UniversalEditModal/components/LabeledSelect"
import Select from "../../../../../shared/components/UI/Select"
import MultiSelect from "../../../../../shared/components/UI/MultiSelect"
import Checkbox from "../../../../../shared/components/UI/Checkbox"
import CalendarWindow from "../../../../../shared/components/UI/Calendar/CalendarWindow"
import MultiSidesSelector from "../../../components/multiSidesSelector/MultiSidesSelector"
import Image from "../../../../../shared/components/other/Image/Image"
import Button from "../../../../../shared/components/UI/Button"
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices"
import useTypesValues from "../../../../../shared/hooks/useTypesValues"
import useEventFilterTypes from "../../../../Сalendar/hooks/useFilters"
import useEventValuesForEdit from "../hooks/useEventValuesForEdit"
import useGetEventParty from "../../../../../shared/hooks/useGetEventParty"
import useCreateEvent from "../../../../../shared/hooks/useCreateEvent"
import useEditEvent from "../../../../../shared/hooks/useEditEvent"
import useDeleteImage from "../hooks/useDeleteImage"
import useOrganizersCalendar from "../../../hooks/useOrganizers"
import CreateEventFormSkeleton from "./CreateEventFormSkeleton"
import ConfirmModal from "../../../../../shared/components/UI/ConfirmModal"

//TODO: в будущем (после рефакторинга Select и MultiSelect) необходимо добавить скроллинг с помощью свойства setFocus, чтобы валидация и исправление ошибок проиходили более комфортно для пользователя
//TODO: во время рефакторинга MultiSelect сделать поддержку валидации 

interface Image {
    image_link: string,
    is_preview: boolean
}

interface FormValues {
    name: string;
    description: string;
    type: string;
    reg_type: string;
    subtypes?: string[];
    is_reg_validation_required: boolean;
    ground?: string;
    start_datetime: string;
    end_datetime: string;
    pricing?: string;
    event_hosts?: string[];
    is_entry_reason_required: boolean;
    sides?: any[];
    rent_available: boolean;
    state: string;
    is_active: boolean;
    is_visible: boolean;
    is_payment_accepted?: boolean,
    imagesFile?: File[];
    previewFile?: File;
    images?: Image[];
    kmzFile?: File;
}

interface FormProps {
    isCreate: boolean;
    eventSlug?: string;
    onDirtyChange?: (isDirty: boolean) => void;
    onClose?: () => void;
}

const CreateEventForm = ({ isCreate, eventSlug, onDirtyChange, onClose }: FormProps) => {
    const { organizers } = useOrganizersCalendar({
        my: true
    })
    const { data: filterTypes } = useEventFilterTypes()
    const { data: typesData } = useTypesValues()
    const { data: eventInfo } = useEventValuesForEdit(eventSlug)
    const { data: eventParties } = useGetEventParty(eventSlug)
    const { mutate: createEvent, isPending: isPendingCreation } = useCreateEvent()
    const { mutate: editEvent, isPending: isPendingEdit } = useEditEvent(eventSlug)
    const { mutate: deleteImage } = useDeleteImage(eventSlug)
    const { guID } = useParams()
    const organizerSlug = guID && guID !== eventSlug ? guID : ''

    const [isShowInCalendar, setIsShowInCalendar] = useState(false)
    const [imagesFile, setImagesFile] = useState<string[]>([])
    const [imagesData, setImagesData] = useState<Image[]>([])
    const [previewObject, setPreviewObject] = useState<string | null>(null)
    const [previewFile, setPreviewFile] = useState<File | undefined>(undefined)
    const [kmzFile, setKmzFile] = useState<File | undefined>(undefined)
    const [kmzFileName, setKmzFileName] = useState<string>('')
    const [isLoaded, setIsLoaded] = useState(false)
    const [isTeamBattle, setIsTeamBattle] = useState(false)
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)


    const methods = useForm<FormValues>({
        defaultValues: {
            subtypes: [],
            event_hosts: [],
            is_reg_validation_required: false,
            rent_available: false,
            is_entry_reason_required: false,
            is_visible: false
        },
        mode: 'all'
    })

    const {
        register,
        formState,
        getValues,
        setValue,
        watch,
        control,
        handleSubmit,
        reset
    } = methods

    const { isDirty } = formState

    useEffect(() => {
        if (!isCreate && eventInfo && eventParties && filterTypes && !isLoaded) {
            const formattedData = {
                ...eventInfo,
                ground: filterTypes?.grounds.find((ground: any) => ground.slug === eventInfo.ground)?.name || '',
                type: eventInfo.subtypes[0]?.global_type_name || '',
                is_reg_validation_required: !!eventInfo.is_reg_validation_required,
                is_entry_reason_required: !!eventInfo.is_entry_reason_required,
                rent_available: !!eventInfo.rent_available,
                is_visible: !!eventInfo.is_visible,
                start_datetime: eventInfo.start_datetime,
                end_datetime: eventInfo.end_datetime,
                subtypes: Object.fromEntries((eventInfo.subtypes || []).map((s: any) => [s.sub_type_name, true])),
                event_hosts: Object.fromEntries((eventInfo.event_hosts || []).map((h: any) => [h.slug, true])),
                reg_type: filterTypes?.reg_types.find((type: any) => type.id === eventInfo.reg_type)?.name || '',
                sides: eventParties
            }
            reset(formattedData)
            setIsShowInCalendar(formattedData.is_visible)
            setImagesData(eventInfo.images)
            setIsTeamBattle(formattedData.reg_type === "Битва команд")
            const preview = eventInfo.images.find((i: any) => i.is_preview)?.image_link
            if (preview) setPreviewObject(preview)
            setIsLoaded(true)
        }
    }, [eventInfo, eventParties, isCreate, filterTypes, reset, isLoaded])

    const selectedType = typesData?.find((item: any) => item.type === watch('type'))
    const subtypes = selectedType ? selectedType.subtypes : []

    const isRegTypeDisabled = !isCreate && eventInfo?.state !== "announced"

    const isAddSidesSelectorDisabled = !isCreate && eventInfo?.state !== "announced"

    const regType = watch("reg_type")

    useEffect(() => {
        if (!isRegTypeDisabled) {
            setIsTeamBattle(regType === "Битва команд")
        }
    }, [regType, isRegTypeDisabled])

    useEffect(() => {
        if (onDirtyChange) {
            onDirtyChange(isDirty)
        }
    }, [isDirty, onDirtyChange])

    const prepareFormData = (data: FormValues) => {
        const newImages = !previewFile && data.images?.map((i) => ({
            ...i,
            is_preview: i.image_link === previewObject
        }))

        const filesToUpload = data.imagesFile?.filter((i) => i !== previewFile)
        const selectedRegType = filterTypes?.reg_types?.find((type: any) => type.name === data.reg_type)
        const selectedGround = filterTypes?.grounds?.find((ground: any) => ground.name === data.ground)

        const selectedSubtypesObj = getValues("subtypes") as unknown as Record<string, boolean> || []
        const selectedSubtypes = Object.keys(selectedSubtypesObj).filter(key => selectedSubtypesObj[key])

        const mainHost = !isCreate ? eventInfo?.event_hosts?.find((h: any) => h.is_main_host)?.slug : ''

        const selectedHostsObj = getValues("event_hosts") as unknown as Record<string, boolean> || []
        let selectedHosts = Object.keys(selectedHostsObj).filter(key => selectedHostsObj[key])

        let newMainHost: string | undefined

        if (isCreate) {
            if (!selectedHosts.includes(organizerSlug)) {
                selectedHosts.push(organizerSlug)
            }
            newMainHost = organizerSlug
        } else {
            if (mainHost && selectedHosts.includes(mainHost)) {
                newMainHost = mainHost
            } else if (selectedHosts.length > 0) {
                newMainHost = selectedHosts[0]
            } else if (mainHost) {
                selectedHosts = [mainHost]
                newMainHost = mainHost
            } else {
                newMainHost = selectedHosts[0]
            }
        }

        const newSides = data.sides?.filter(side => !side.id) ?? []

        return {
            ...data,
            ground: selectedGround.slug,
            is_payment_accepted: !!data.pricing?.trim(),
            reg_type: selectedRegType.id,
            is_visible: true,
            is_active: false,
            subtypes: selectedSubtypes.map((subtype) => ({
                global_type_name: data.type,
                sub_type_name: subtype ? subtype : ''
            })),
            event_hosts: selectedHosts.map((host) => ({
                slug: host,
                is_main_host: host === newMainHost
            })),
            images: newImages ? newImages : data.images,
            imagesFile: filesToUpload,
            previewFile: previewFile,
            kmzFile: kmzFile,
            sides: newSides
        }
    }

    const onSubmit: SubmitHandler<FormValues> = data => {
        // console.log(data)
        if (!previewFile && !previewObject && (imagesData.length > 0 || imagesFile.length > 0)) {
            displayNotify({
                status: 'error',
                title: 'Выберите обложку',
                description: 'Необходимо выбрать обложку из загруженных изображений'
            })
            return null
        }

        if ((!data.sides || data.sides?.length === 0) && !isTeamBattle) {
            displayNotify({
                status: 'error',
                title: 'Добавьте стороны',
                description: 'Необходимо добавить хотя бы одну сторону на мероприятие'
            })
            return null
        }

        const finalData = prepareFormData(data)

        // console.log(finalData)

        const onSuccess = () => {
            reset(getValues())
            onClose?.()
        }

        isCreate
            ? createEvent(finalData, { onSuccess })
            : editEvent(finalData, { onSuccess })
    }

    const errors = formState.errors

    const onError = (errors: any) => {
        const firstError: any = Object.values(errors)[0]

        let description = 'Неверно заполнены поля'

        switch (firstError?.type) {
            case 'required':
                description = 'Заполните обязательные поля'
                break

            case 'validate':
                if (firstError.message === 'Это обязательное поле') {
                    description = 'Заполните обязательные поля'
                }
                break
        }

        displayNotify({
            status: 'error',
            title: 'Проверьте данные',
            description
        })

        requestAnimationFrame(() => {
            const firstErrorEl = document.querySelector('.invalid-text')

            if (firstErrorEl) {
                firstErrorEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        })
    }

    const handleDeleteLocalImage = (index: number, field: any) => {
        setImagesFile((prev) => prev.filter((_, i) => i !== index))
        const newFiles = (field.value || []).filter((_: File, i: number) => i !== index)
        field.onChange(newFiles)
    }

    const handleDeleteImage = (image_link: string) => {
        deleteImage(image_link)
    }


    const formError = (fieldName: keyof FormValues, rules?: { min?: number, max?: number }) => {
        const error = formState.errors[fieldName]
        if (!error) return null

        if (error.message) {
            return <p className="invalid-text">{error.message}</p>
        }

        switch (error.type) {
            case 'required':
                return <p className="invalid-text">Это обязательное поле</p>;
            case 'minLength':
                return <p className="invalid-text">Поле должно содержать не менее {rules?.min || 0} символов</p>
            case 'maxLength':
                return <p className="invalid-text">Поле должно содержать не более {rules?.max || 0} символов</p>
            default:
                return null
        }
    }

    const handleCancel = () => {
        editEvent(
            { state: 'cancelled' } as any,
            {
                onSuccess: () => {
                    displayNotify({
                        status: 'success',
                        title: 'Мероприятие отменено',
                        description: 'Мероприятие успешно отменено'
                    })
                    setIsConfirmModalOpen(false)
                    onClose?.()
                },
                onError: () => {
                    displayNotify({
                        status: 'error',
                        title: 'Не удалось отменить мероприятие',
                        description: 'Попробуйте ещё раз позже'
                    })
                }
            }
        )
    }


    // Показываем скелетон только при редактировании и пока не загружены данные
    if (!isCreate && !isLoaded) {
        return <CreateEventFormSkeleton />;
    }

    return (
        <FormProvider {...methods}>
            <form className="manageEventModal__createForm" onSubmit={handleSubmit(onSubmit, onError)}>
                <h2>Информация о событии</h2>

                <div className="manageEventModal__createForm-fieldWrapper">
                    <LabeledInput
                        label="Название"
                        inputName="name"
                        watch={watch}
                        errors={errors}
                        classes={{
                            wrapper: 'manageEventModal__createForm-input-wrapper',
                            field: 'manageEventModal__createForm-input-field'
                        }}
                        {...register("name", { minLength: 3, maxLength: 40, required: true })}
                    />
                    {formError('name', { min: 3, max: 40 })}
                </div>


                <div className="manageEventModal__createForm-fieldWrapper">
                    <LabeledTextarea
                        label="Описание события"
                        textareaName="description"
                        errors={errors}
                        watch={watch}
                        classes={{
                            field: 'manageEventModal__createForm-textarea-field',
                            label: 'manageEventModal__createForm-textarea-label'
                        }}
                        {...register("description", { minLength: 5, maxLength: 500 })}
                    />
                    {formError('description', { min: 5, max: 500 })}
                </div>


                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name='type'
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <LabeledSelect
                                label="Тип мероприятия"
                                value={field.value}
                                options={typesData?.map((type: any) => ({ value: type.type, label: type.type }))}
                                setValue={(name, value) => {
                                    field.onChange(value)
                                    setValue('subtypes', [])
                                }}
                                formName={field.name}
                                classes={{
                                    select:
                                        `manageEventModal__createForm-select ${formState.errors.type && 'invalid'}`,
                                    select_wrapper:
                                        `manageEventModal__createForm-select-wrapper ${formState.errors.type && 'invalid'}`,
                                    select_arrow:
                                        "manageEventModal__createForm-select-arrow",
                                    select_options:
                                        "manageEventModal__createForm-select-options",
                                    select_value:
                                        "manageEventModal__createForm-select-value"
                                }}
                            />
                        )}
                    />
                    {formError('type')}
                </div>


                {(selectedType || !isCreate) && (
                    <div className="manageEventModal__createForm-fieldWrapper">
                        <Controller
                            name='subtypes'
                            control={control}
                            rules={{
                                required: true,
                                validate: (value) => {
                                    if (!value || Object.values(value).every(v => !v)) {
                                        return 'Это обязательное поле'
                                    }
                                    return true
                                }
                            }}
                            render={({ field }) => (
                                <MultiSelect
                                    className={`manageEventModal__createForm-multiselect ${formState.errors.subtypes && 'invalid'}`}
                                    options={subtypes}
                                    setValue={setValue}
                                    title="Подтипы мероприятия"
                                    name="subtypes"
                                    getValues={getValues}
                                    watch={watch}
                                    hasSearch={false}
                                    formName={field.name}
                                    items={subtypes?.map((s: string) => ({ id: s, name: s })) || []}
                                    isAddMoreOptions={true}
                                    usesInForm={true}
                                    grayStyle
                                />
                            )}
                        />
                        {formError('subtypes')}
                    </div>
                )}


                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name='reg_type'
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <LabeledSelect
                                label="Тип регистрации"
                                value={field.value}
                                options={filterTypes?.reg_types?.map((type: any) => ({ value: type.id, label: type.name }))}
                                setValue={setValue}
                                formName={field.name}
                                disabled={isRegTypeDisabled}
                                disabledMessage={{
                                    title: 'Изменения недоступны',
                                    description: 'Изменить тип регистрации можно только в статусе «Анонсировано»',
                                }}
                                classes={{
                                    select:
                                        `manageEventModal__createForm-select ${formState.errors.reg_type && 'invalid'}`,
                                    select_wrapper:
                                        `manageEventModal__createForm-select-wrapper ${formState.errors.reg_type && 'invalid'}`,
                                    select_arrow:
                                        "manageEventModal__createForm-select-arrow",
                                    select_options:
                                        "manageEventModal__createForm-select-options",
                                    select_value:
                                        "manageEventModal__createForm-select-value"
                                }}
                            />
                        )}
                    />
                    {formError('reg_type')}
                </div>


                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name="is_reg_validation_required"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                            <Checkbox
                                label={'Ручное подтверждение регистрации'}
                                name="manualConfirm"
                                value={watch('is_reg_validation_required')}
                                labelStyle={{}}
                                checked={watch('is_reg_validation_required')}
                                onChange={field.onChange}
                                className="darkCheckbox"
                                textColor='#62666D'
                            />
                        )}
                    />
                    <p className="">Участники будут добавляться только после Вашего одобрения</p>
                </div>


                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name='ground'
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <LabeledSelect
                                label="Место проведения"
                                value={field.value ?? ''}
                                options={filterTypes?.grounds?.map((ground: any) => ({ value: ground.slug, label: ground.name }))}
                                setValue={setValue}
                                formName={field.name}
                                classes={{
                                    select:
                                        `manageEventModal__createForm-select ${formState.errors.ground && 'invalid'}`,
                                    select_wrapper:
                                        `manageEventModal__createForm-select-wrapper ${formState.errors.ground && 'invalid'}`,
                                    select_arrow:
                                        "manageEventModal__createForm-select-arrow",
                                    select_options:
                                        "manageEventModal__createForm-select-options",
                                    select_value:
                                        "manageEventModal__createForm-select-value"
                                }}
                            />
                        )}
                    />
                    {formError('ground')}
                </div>

                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name='start_datetime'
                        control={control}
                        rules={{
                            required: true,
                            validate: (value) => {
                                const date = new Date(value)

                                if (isNaN(date.getTime())) {
                                    return 'Некорректная дата'
                                }

                                if (date < new Date()) {
                                    return 'Дата не может быть в прошлом'
                                }

                                return true
                            }
                        }}
                        render={({ field }) => (
                            <CalendarWindow
                                placeholder="Дата и время начала"
                                isLabeled={true}
                                value={field.value}
                                onValidDate={(iso) => setValue('start_datetime', iso)}
                                classes={{
                                    calendar_input: `manageEventModal__createForm-calendar ${formState.errors.start_datetime && 'invalid'}`
                                }}
                            />)
                        } />
                    {formError('start_datetime')}
                </div>

                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name='end_datetime'
                        control={control}
                        rules={{
                            required: true,
                            validate: (value, formValues) => {
                                const start = new Date(formValues.start_datetime)
                                const end = new Date(value)

                                if (isNaN(end.getTime())) return 'Некорректная дата'

                                if (end < new Date()) {
                                    return 'Дата не может быть в прошлом'
                                }

                                if (end <= start) return 'Дата окончания должна быть позже начала'

                                return true
                            }
                        }}
                        render={({ field }) => (
                            <CalendarWindow
                                placeholder="Дата и время окончания"
                                isLabeled={true}
                                value={field.value}
                                onValidDate={(iso) => setValue('end_datetime', iso)}
                                classes={{
                                    calendar_input: `manageEventModal__createForm-calendar ${formState.errors.end_datetime && 'invalid'}`
                                }}
                            />
                        )}
                    />
                    {formError('end_datetime')}
                </div>

                <LabeledInput
                    label="Взнос"
                    inputName="pricing"
                    watch={watch}
                    errors={errors}
                    classes={{
                        wrapper: 'manageEventModal__createForm-input-wrapper',
                        field: 'manageEventModal__createForm-input-field'
                    }}
                    {...register("pricing")}
                />

                <div className="images">
                    <h3>
                        Изображения
                    </h3>

                    <div className="images__icons">
                        <Controller
                            name="images"
                            control={control}
                            render={({ field }) => (
                                <>
                                    {imagesData?.map((img: Image) => (
                                        <div className="images__image-wrapper">
                                            <div
                                                className='images__image'
                                                onClick={() => {
                                                    setPreviewObject(img.image_link)
                                                    if (previewFile) {
                                                        setPreviewFile(undefined)
                                                    }
                                                }}
                                            >
                                                <Image
                                                    src={img.image_link}
                                                    resolution='slider'
                                                    className={`images__image-user ${previewObject === img.image_link && 'preview'}`}
                                                    sizes='90px'
                                                />
                                            </div>
                                            <div
                                                className="images__image-delete-wrapper"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setImagesData(prev => prev.filter(i => i !== img))
                                                    handleDeleteImage(img.image_link)
                                                }}
                                            >
                                                <div className="images__image-delete" />
                                            </div>
                                            {previewObject === img.image_link && <p>Обложка</p>}
                                        </div>
                                    ))}
                                </>
                            )}
                        />

                        <Controller
                            name="imagesFile"
                            control={control}
                            render={({ field }) => (
                                <>
                                    {imagesFile?.map((src: string, id: number) => (
                                        <div className="images__image-wrapper">
                                            <div
                                                key={id}
                                                className='images__image'
                                                onClick={() => {
                                                    const currentFile = field.value?.[id] as File | undefined
                                                    if (currentFile) setPreviewFile(currentFile)
                                                    if (previewObject) {
                                                        setPreviewObject(null)
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={src}
                                                    className={`images__image-user ${previewFile === field.value?.[id] && 'preview'}`}

                                                />
                                                <div
                                                    className="images__image-delete-wrapper"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        handleDeleteLocalImage(id, field)
                                                    }}
                                                >
                                                    <div className="images__image-delete" />
                                                </div>
                                            </div>
                                            {previewFile === field.value?.[id] && <p>Обложка</p>}
                                        </div>)
                                    )
                                    }

                                    <label className="images__uploadButton">
                                        <input
                                            type="file"

                                            accept="image/png, image/jpeg, image/jpg"
                                            onChange={(e) => {
                                                const files = e.target.files ? Array.from(e.target.files) : []
                                                if (files.length > 0) {
                                                    field.onChange([...(field.value || []), ...files])

                                                    const newImages = files.map((file) =>
                                                        URL.createObjectURL(file) as string
                                                    )

                                                    setImagesFile((prev) => [...prev, ...newImages])
                                                }
                                            }}
                                        />
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 22 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M17.375 3.5H5.125C4.1585 3.5 3.375 4.2835 3.375 5.25V17.5C3.375 18.4665 4.1585 19.25 5.125 19.25H17.375C18.3415 19.25 19.125 18.4665 19.125 17.5V5.25C19.125 4.2835 18.3415 3.5 17.375 3.5Z"
                                                stroke="#E5E4DF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M11.25 7.875V14.875"
                                                stroke="#E5E4DF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.75 11.375H14.75"
                                                stroke="#E5E4DF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </label>
                                </>
                            )}
                        />
                    </div>
                    <p>
                        Выбранное изображение будет использоваться как обложка
                    </p>
                </div>

                <div className="kmz-upload">
                    <h3>
                        Карта полигона
                    </h3>

                    <div className="kmz-upload__wrapper">
                        {kmzFileName ? (
                            <div className="kmz-upload__file-info">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 19V8L14 2Z" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14 2V8H20" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 13H8" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M16 17H8" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10 9H8" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span>{kmzFileName}</span>
                                <button
                                    type="button"
                                    className="kmz-upload__delete"
                                    onClick={() => {
                                        setKmzFile(undefined)
                                        setKmzFileName('')
                                        setValue('kmzFile', undefined)
                                    }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 6L6 18" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M6 6L18 18" stroke="#E5E4DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        ) : (
                            <label className="kmz-upload__button">
                                <input
                                    type="file"
                                    accept=".kmz,application/vnd.google-earth.kmz"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0]
                                        if (file) {
                                            if (file.size > 50 * 1024 * 1024) { // 50MB limit
                                                displayNotify({
                                                    status: 'error',
                                                    title: 'Файл слишком большой',
                                                    description: 'Максимальный размер файла — 50 МБ'
                                                })
                                                e.target.value = ''
                                                return
                                            }
                                            setKmzFile(file)
                                            setKmzFileName(file.name)
                                            setValue('kmzFile', file)
                                        }
                                    }}
                                />
                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M17.375 3.5H5.125C4.1585 3.5 3.375 4.2835 3.375 5.25V17.5C3.375 18.4665 4.1585 19.25 5.125 19.25H17.375C18.3415 19.25 19.125 18.4665 19.125 17.5V5.25C19.125 4.2835 18.3415 3.5 17.375 3.5Z"
                                        stroke="#E5E4DF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11.25 7.875V14.875"
                                        stroke="#E5E4DF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.75 11.375H14.75"
                                        stroke="#E5E4DF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </label>
                        )}
                    </div>
                    <p className="kmz-upload__hint">
                        Поддерживается один файл формата .kmz (макс. 50 МБ)
                    </p>
                </div>

                <div style={{ position: "relative" }}>
                    <MultiSelect
                        className="manageEventModal__createForm-multiselect"
                        options={organizers?.map((host: any) => host.name)}
                        shouldSubmitOnReset = {false}
                        setValue={setValue}
                        title="Организаторы"
                        name="event_hosts"
                        getValues={getValues}
                        watch={watch}
                        hasSearch={false}
                        formName="event_hosts"
                        items={organizers?.map((host: any) => ({ name: host.name, slug: host.slug })) || []}
                        isAddMoreOptions={true}
                        usesInForm={true}
                        grayStyle
                    >
                    </MultiSelect>
                </div>

                {!isTeamBattle && <div>
                    <MultiSidesSelector
                        title="Стороны"
                        className="manageEventModal__createForm-multiselect sides"
                        formName='sides'
                        eventSlug={eventSlug}
                        disabled={isAddSidesSelectorDisabled}
                        disabledMessage={{
                            title: 'Изменения недоступны',
                            description: 'Изменить стороны можно только в статусе «Анонсировано»',
                        }}
                    />

                    <p>
                        Нажмите "+", чтобы добавить сторону <br />
                        Чтобы отредактировать, нажмите на сторону
                    </p>
                </div>}

                <div className="manageEventModal__createForm-fieldWrapper">
                    <Controller
                        name="is_entry_reason_required"
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                            <Checkbox
                                label={'Требуется обоснования для допуска на игру'}
                                name="isRequireJustification"
                                value={field.value}
                                labelStyle={{}}
                                checked={field.value}
                                onChange={field.onChange}
                                className="darkCheckbox"
                                textColor='#62666D'
                            />
                        )}
                    />
                    <p>Игрок должен указать причину допуска</p>
                </div>

                <Controller
                    name="rent_available"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                        <Checkbox
                            label={'Аренда снаряжения'}
                            name="isRent"
                            value={field.value}
                            labelStyle={{}}
                            checked={field.value}
                            onChange={field.onChange}
                            className="darkCheckbox"
                            textColor='#62666D'
                        />
                    )}
                />
                <div className="manageEventModal__createForm-buttons">
                    {!isCreate && (
                        <Button
                            className='manageEventModal__createForm-cancelButton'
                            onClick={() => setIsConfirmModalOpen(true)}
                        >
                            Отменить мероприятие
                        </Button>
                    )}
                    <Button
                        className="manageEventModal__createForm-saveButton"
                        type="submit"
                        disabled={isPendingCreation || isPendingEdit}
                    >
                        {isCreate ? "Создать мероприятие" : "Сохранить"}
                    </Button>
                </div>

                {isConfirmModalOpen && (
                    <ConfirmModal
                        text="Отмена мероприятия"
                        description="Вы уверены, что хотите отменить мероприятие? Это действие нельзя будет отменить."
                        confirmText="Да, отменить"
                        cancelText="Нет"
                        onConfirm={handleCancel}
                        closeModal={() => setIsConfirmModalOpen(false)}
                        isPending={isPendingEdit}
                    />
                )}
            </form>
        </FormProvider>
    )
}

export default CreateEventForm